import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Chip,
  Divider,
} from '@mui/material';
import { EmojiEvents } from '@mui/icons-material';

const BidHistory = ({ bids }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  if (!bids || bids.length === 0) {
    return (
      <Box textAlign="center" py={4}>
        <Typography color="text.secondary">
          No bids yet. Be the first to bid!
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Bid History
      </Typography>

      <List>
        {bids.map((bid, index) => (
          <React.Fragment key={bid.id}>
            <ListItem
              secondaryAction={
                bid.is_winning && (
                  <Chip
                    icon={<EmojiEvents />}
                    label="Winning"
                    color="success"
                    size="small"
                  />
                )
              }
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: bid.is_winning ? 'success.main' : 'grey.400' }}>
                  {bid.bidder?.first_name?.[0] || 'B'}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="body1" fontWeight="bold">
                      {formatPrice(bid.bid_amount)}
                    </Typography>
                  </Box>
                }
                secondary={
                  <Box>
                    <Typography variant="body2" component="span">
                      {bid.bidder
                        ? `${bid.bidder.first_name} ${bid.bidder.last_name[0]}.`
                        : 'Anonymous'}
                    </Typography>
                    <Typography variant="caption" component="span" sx={{ ml: 1 }}>
                      {formatDate(bid.bid_time)}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
            {index < bids.length - 1 && <Divider variant="inset" component="li" />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default BidHistory;
